<template>
    <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.12133 4.93935H0V7.06067H2.12133V4.93935Z" fill="currentcolor"/>
        <path d="M6.36443 4.93935H4.2431V7.06067H6.36443V4.93935Z" fill="currentcolor"/>
        <path d="M23.1452 5.99998L21.6452 4.49998L17.1452 0L15.6452 1.49999L19.0845 4.93934H8.48624V7.06066H19.0845L15.6452 10.5L17.1452 12L21.6452 7.49999V7.50002L23.1452 6H23.1452L23.1452 5.99998Z" fill="currentcolor"/>
    </svg>
</template>

<script>
export default {
	name: "ArrowVector"
};
</script>
